import { AuthModel } from '@gtpl/shared-models/common-models';
import { Module } from '@nestjs/common';
import { wareHouseBullQueues } from './warehouse-bull-queue';
import { WarehouseJobsController } from './warehouse-jobs.controller';
import { WarehouseJobsService } from './warehouse-jobs.service';
@Module({
  imports: [...wareHouseBullQueues],
  controllers: [WarehouseJobsController],
  providers: [WarehouseJobsService, AuthModel],
  exports: [ ...wareHouseBullQueues],
})
export class WarehouseJobQueuesModule { }
